module.exports = __webpack_public_path__ + "media/newstyle/images/icon-mini-book-54e68e6e99478a9c9fb10cb27b0cb749.svg";